/**
 * FormatStep.tsx — step 2 of the VER-128 Create Programme preview: "How will you deliver?"
 * Maps to Programme.isGroup / Programme.classroomId once this is wired to a real save —
 * see createProgramme.types.ts.
 */
import React from "react";
import { Grid, Stack, Typography } from "@mui/material";
import { DELIVERY_FORMATS } from "./createProgramme.mock";
import { DELIVERY_FORMAT_ICONS } from "./createProgramme.icons";
import { DeliveryFormatKey } from "./createProgramme.types";
import { SelectableOptionCard } from "./SelectableOptionCard";

type FormatStepProps = {
    value: DeliveryFormatKey;
    onChange: (value: DeliveryFormatKey) => void;
};

export const FormatStep: React.FC<FormatStepProps> = ({ value, onChange }) => {
    return (
        <Stack spacing={3.5}>
            <Stack spacing={1}>
                <Typography variant="overline" color="primary.main">
                    Step 2 of 4
                </Typography>
                <Typography variant="h3" component="h2" color="secondary.main">
                    How will you deliver?
                </Typography>
                <Typography variant="body1" color="secondary.dark" sx={{ lineHeight: 1.6 }}>
                    Choose the format that matches your setting. This determines the assessment model and dashboard
                    type.
                </Typography>
            </Stack>

            <Grid container spacing={2}>
                {DELIVERY_FORMATS.map((option) => (
                    <Grid item xs={12} sm={6} key={option.key}>
                        <SelectableOptionCard
                            title={option.title}
                            body={option.body}
                            icon={DELIVERY_FORMAT_ICONS[option.key]}
                            selected={value === option.key}
                            onClick={() => onChange(option.key)}
                            tag={option.tag}
                            tagColor={option.tagTone}
                            iconInTile
                        />
                    </Grid>
                ))}
            </Grid>
        </Stack>
    );
};
